export function createPosRealtimeGate({
    echo,
    channelName,
    required,
    configured,
    isOnline,
    sync,
    markUnavailable,
    onStateChange,
}) {
    let state = required
        ? configured
            ? 'connecting'
            : 'unavailable'
        : 'not_required';
    let connected = false;
    let subscribed = false;
    let generation = 0;
    let channel;
    let stopConnectionListener = () => {};

    const transition = (nextState) => {
        state = nextState;
        onStateChange(nextState);
    };

    const block = async () => {
        if (!required) {
            return;
        }

        generation += 1;
        connected = false;
        subscribed = false;
        transition('unavailable');
        await markUnavailable();
    };

    const synchronize = async () => {
        if (!connected || !subscribed || !isOnline()) {
            return;
        }

        const attempt = ++generation;
        transition('syncing');

        try {
            const ready = await sync();

            if (
                attempt !== generation ||
                !connected ||
                !subscribed ||
                !isOnline()
            ) {
                return;
            }

            transition(ready ? 'ready' : 'unavailable');

            if (!ready) {
                await markUnavailable();
            }
        } catch {
            if (attempt === generation) {
                await block();
            }
        }
    };

    const api = {
        get state() {
            return state;
        },
        disconnect() {
            return block();
        },
        destroy() {
            generation += 1;
            stopConnectionListener();

            if (channel) {
                echo.leave(channelName);
            }
        },
    };

    transition(state);

    if (!required || !configured || !echo || !channelName) {
        return api;
    }

    channel = echo
        .private(channelName)
        .listen('.pos.order.changed', synchronize)
        .listen('.kds.order.updated', synchronize);

    channel
        .subscribed(() => {
            subscribed = true;
            connected = echo.connectionStatus() === 'connected';

            return synchronize();
        })
        .error(() => block());

    stopConnectionListener = echo.connector.onConnectionChange((status) => {
        if (status === 'connected') {
            connected = true;

            return subscribed ? synchronize() : undefined;
        }

        return block();
    });
    connected = echo.connectionStatus() === 'connected';

    return api;
}
